import React from 'react';
import './ConfirmModal.css';

function ConfirmModal({ title, message, confirmText = 'Delete', cancelText = 'Cancel', onConfirm, onCancel, variant = 'danger' }) {
  return (
    <div className="confirm-overlay" onClick={onCancel}>
      <div className="confirm-modal" onClick={e => e.stopPropagation()}>
        <h3 className="confirm-title">{title}</h3>
        <p className="confirm-message">{message}</p>
        <div className="confirm-actions">
          <button className="confirm-cancel-btn" onClick={onCancel}>{cancelText}</button>
          <button className={`confirm-btn confirm-${variant}`} onClick={onConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
